const PopupProcessing = () => {
  return (
    <div className='flex items-center justify-center h-full'>
      <img src={require('assets/images/okg-loading-logo.gif').default} className='h-40 md:h-auto' />
    </div>
  );
};

export default PopupProcessing;
